<template>

	<div class="bkf7 galist_wbox">

		<div class="inter">
			<div class="all_game_list">
				<div class="wbox">
					<div class="all_game_list">
						<div class="list_title">
							<div class="tabs">
								<div class="tabs-title"><span class="title cp">游戏推荐</span>
									<div class="tabs-more">
										<div class="mt-2"><span class="text-span" :class="{'active':now_type == 0}"
												@click="opneAll(0)">
												热门游戏
											</span><span class="text-span" :class="{'active':now_type == 1}"
												@click="opneAll(1)">
												端游
											</span><span class="text-span" :class="{'active':now_type == 2}"
												@click="opneAll(2)">
												手游
											</span></div> <a href="/gameList" class="more">更多游戏</a>
									</div>
								</div>
							</div>
						</div>

						<div class="list_content history-data">

							<router-link class="cp content_item" :to="{path: 'game', query: {gtype: item.id}}"
								v-for="(item, index) in home_game">
								<img :src="fixImageUrl(item.image)">
								<div class="text-565 img-text f14 tc mt-5">{{item.name}}</div>

							</router-link>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title: "",
				home_game: [],
				now_type: 0,
			}
		},
		created: function(data) {

			// this.getmenu();
			this.getNewgame()

		},

		computed: {
			gamelist() {
				return this.$store.getters.gamelist
			},
			config() {
				return this.$store.getters.config
			},
		},
		watch: {
			$route() {

			}
		},
		methods: {
			opneAll(e) {
				this.now_type = e;
				this.getNewgame()
			},


			getNewgame() {
				this.rq.requests.post("api/game/hall/getNewGameList2", {
					type: this.now_type,
				}).then(res => {
					this.home_game = res.data
				}).catch(error => {

				})
			},


			chose(index) {
				this.$data.active = this.$data.list[index].id;
				this.content = this.$data.list[index].content;
			},
			getmenu() {
				var that = this;
				this.rq.requests.post("api/hall/getchives", {
					id: 46,
				}).then(res => {
					that.$data.list = res.data;
					if (that.$data.list.length > 0) {
						that.$data.active = that.$data.list[0].id;
						that.content = that.$data.list[0].content;
						that.title = that.$data.list[0].title;
					}

				}).catch(error => {

				})
			},

		}


	}
</script>